import React, { useState, useRef, useEffect } from "react";
import "../styles/AuthPage.css"; // ⬅ Importujemy CSS

const AuthPage = ({ onAuthSuccess }) => {
  const [passwordParts, setPasswordParts] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false); // ⬅ Stan ładowania
  const inputsRef = useRef([]);
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);
  const checkauthkeyUrl = process.env.REACT_APP_Check_Auth_Key;

  // ⚡ Automatyczne skalowanie kontenera
  useEffect(() => {
    const updateScale = () => {
      if (!containerRef.current) return;

      const { innerWidth, innerHeight } = window;
      const baseWidth = 400;
      const baseHeight = 500;
      const scaleFactor = Math.min(innerWidth / baseWidth, innerHeight / baseHeight, 1);

      setScale(scaleFactor);
    };

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  // Obsługa zmiany wartości inputa
  const handleChange = (index, value) => {
    if (!/^[a-zA-Z0-9]{0,2}$/.test(value)) return; // Pozwala na litery i cyfry

    const newPasswordParts = [...passwordParts];
    newPasswordParts[index] = value;
    setPasswordParts(newPasswordParts);

    if (value.length === 2 && index < 3) {
      setTimeout(() => inputsRef.current[index + 1]?.focus(), 50);
    }

    if (index === 3 && value.length === 2) {
      setTimeout(() => handleLogin(newPasswordParts.join("")), 100);
    }
  };

  // Funkcja wysyłania kodu do backendu
  const handleLogin = async (fullPassword) => {
    setError("");
    setIsLoading(true); // ⬅ Rozpoczęcie animacji przycisku

    try {
      const response = await fetch(checkauthkeyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: fullPassword }),
      });

      const data = await response.json();

      if (data.success) {
        onAuthSuccess(fullPassword);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(" Błąd połączenia z serwerem.");
      console.error("🚨 Błąd:", error);
    }

    setIsLoading(false); // ⬅ Koniec animacji
  };

  return (
    <div className="auth-container" ref={containerRef} style={{ transform: `scale(${scale})` }}>
      <div className="auth-card">
        <h2 className="auth-title">🔑 Podaj kod dostępu</h2>
        <div className="auth-inputs">
          {passwordParts.map((part, index) => (
            <React.Fragment key={index}>
              <input
                type="text"
                value={part}
                onChange={(e) => handleChange(index, e.target.value)}
                maxLength="2"
                ref={(el) => (inputsRef.current[index] = el)}
                className="auth-input"
                disabled={isLoading} // ⬅ Blokuje inputy podczas ładowania
              />
              {index < 3 && <span className="auth-separator">:</span>}
            </React.Fragment>
          ))}
        </div>
        <button
          className={`auth-button ${isLoading ? "loading" : ""}`}
          onClick={() => handleLogin(passwordParts.join(""))}
          disabled={isLoading}
        >
          {isLoading ? "🔄 Sprawdzanie..." : "Sprawdź"}
        </button>
        {error && <p className="auth-error">{error}</p>}
      </div>
    </div>
  );
};

export default AuthPage;
